import { useLoaderData, Link } from "react-router-dom";
import FordEventGameMerch from "./FordEventGameMerch";
import { COPY_SLUG, COPY_TERMS_PATH, COPY_COLLECTION } from "../services/merchCopyCampaign";

export function MerchCopyCampaign() {
  const config = useLoaderData();
  return <FordEventGameMerch eventLabel={config.eventLabel} weekendTestDrivePrize={config.weekendTestDrivePrize} registrationEnabled={config.registrationEnabled} campaignOverride={{ slug: COPY_SLUG, name: config.name, eventDate: config.eventDate, collectionName: COPY_COLLECTION, termsPath: COPY_TERMS_PATH }} />;
}
export function TermsBody({ text }) {
  return text.split(/\n\s*\n/).map((block, index) => block.startsWith("РАЗДЕЛ ")
    ? <h2 key={index} className="mt-10 mb-5 text-xl font-semibold text-fordBlue">{block}</h2>
    : <p key={index} className="mb-4 whitespace-pre-wrap break-words leading-7">{block}</p>);
}
export function MerchCopyTerms() {
  const config = useLoaderData();
  return <main className="bg-gray-50 py-12 px-4"><article className="max-w-4xl mx-auto bg-white p-6 sm:p-10 rounded-xl">
    <h1 className="text-3xl text-fordBlue font-semibold">Официални правила за участие в играта</h1>
    <p className="text-xl mt-4">{config.termsTitle}</p>
    <TermsBody text={config.termsText} />
    <Link className="text-fordBlue underline" to={`/landing/${COPY_SLUG}`}>Към играта</Link>
  </article></main>;
}
